export default __webpack_public_path__ + "static/media/006.dde67fc1.png";